/*eslint-disable*/
import React from "react";
import {Container, Row} from "reactstrap";

function IndexHeader() {
    return (
        <Container className="brand pt-4" style={{marginBottom: "-48px"}}>
                {/* <img alt="Logo" className="n-logo" src={require("assets/img/logo.png")}/> */}
                <h1 className="h1-seo">SOEN 490 - Capstone Projects</h1>
        </Container>
    );
}

export default IndexHeader;